import { combineReducers } from 'redux';
import { customerReducer } from './customer';

const RootReducers = combineReducers({ customerReducer });

export default RootReducers;
